import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EqualizerIcon from '@mui/icons-material/Equalizer';
import { AppBar, Box, Button, Grid, Toolbar, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import ChooseLanguage from "../../components/base/ChooseLanguage";
import IconButtonWithTooltip from "../../components/button/IconButtonWithTooltip/IconButtonWithTooltip";
import { useAuth } from "../../context/auth";
import { USER_ROLES } from "../../helpers/constants";
import { useHasRole } from "../../hooks/auth/useCheckPermission";
import useLandingPageService from "../../services/landingPageService";
import { LandingPageTile } from "./LandingPageTile";
import FolderCopyIcon from '@mui/icons-material/FolderCopy'
import { BackGroundImage } from "../../media/background";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';

export const LandingPage = () => {
    const landingPageService = useLandingPageService();
    const { navigateToLogoutRoute, navigateToRedirectBackToMyHomeRoute } = useAuth();
    const { t } = useTranslation();

    const salesManagerPanelPermission = useHasRole([USER_ROLES.SALES_MANAGER, USER_ROLES.ADMIN]);
    const marketingPanelPermission = useHasRole([USER_ROLES.ADMIN, USER_ROLES.SALES_MARKETING]);
    const salesPerimssion = useHasRole([USER_ROLES.ADMIN, USER_ROLES.SALES_LEGAL, USER_ROLES.SALES, USER_ROLES.SALES_MANAGER, USER_ROLES.SALES_MARKETING])

    const leadsCountQuery = useQuery({
        queryKey: ["leadsCount"],
        queryFn: landingPageService.getLeadsCount,
        retry: 1,
    });

    const clientsCountQuery = useQuery({
        queryKey: ["clientsCount"],
        queryFn: landingPageService.getCustomersCount,
        retry: 1,
    });

    const contactsCountQuery = useQuery({
        queryKey: ["contactsCount"],
        queryFn: landingPageService.getContactsCount,
        retry: 1,
    });

    const personsCountQuery = useQuery({
        queryKey: ["personsCount"],
        queryFn: landingPageService.getPersonsCount,
        retry: 1,
    });

    const bookingsCountQuery = useQuery({
        queryKey: ["bookingsCount"],
        queryFn: landingPageService.getBookingsCount,
        retry: 1,
    });

    const productsCountQuery = useQuery({
        queryKey: ["productsCount"],
        queryFn: landingPageService.getProductsCount,
        retry: 1,
    });

    const tasksCountQuery = useQuery({
        queryKey: ["tasksCount"],
        queryFn: landingPageService.getTasksCount,
        retry: 1,
    });

    const offersCountQuery = useQuery({
        queryKey: ["offersCount"],
        queryFn: landingPageService.getOffersCount,
        retry: 1,
    });

    const agreementsCountQuery = useQuery({
        queryKey: ["agreementsCount"],
        queryFn: landingPageService.getAgreementsCount,
        retry: 1,
    });

    const agreementOverduePaymentCountQuery = useQuery({
        queryKey: ["agreementOverduePaymentCount"],
        queryFn: landingPageService.getAgreementOverduePaymentsCount,
        retry: 1,
    });

    const specialSalesStyle = {
        backgroundColor: "hsl(24, 84%, 42%)",
        "&:hover": {
            backgroundColor: "hsl(24, 84%, 52%)",
            transform: "scale(1.03)",
        },
        "&:active": {
            transform: "scale(0.98)",
            backgroundColor: "hsl(24, 84%, 52%)",
            boxShadow: "inset 0 2px 4px rgba(92, 55, 0, 0.42)",
        },
    };

    const marketingPanelButtonStyle = {
        backgroundColor: "hsla(129, 67%, 36%, 1.00)",
        "&:hover": {
            backgroundColor: "hsla(129, 73%, 48%, 1)",
            transform: "scale(1.03)",
        },
        "&:active": {
            transform: "scale(0.98)",
            backgroundColor: "hsla(129, 70%, 44%, 1)",
            boxShadow: "inset 0 2px 4px rgba(92, 55, 0, 0.42)",
        },
    };

    

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                // minHeight: "100vh",
                marginTop: -1,
                backgroundImage: `url(${BackGroundImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                marginBottom: "-200px",
            }}
        >
            {/* AppBar with Logout Button and Language Selector */}
            <AppBar position="static" color="primary">
                <Toolbar sx={{ justifyContent: "flex-end"}}>
                    {/* <div style={{ display: "flex" }}>
                        <IconButtonWithTooltip
                            title={t("back")}
                            onClick={navigateToRedirectBackToMyHomeRoute}
                        >
                            <ArrowBackIcon sx={{ color: "white" }} fontSize="large" />
                        </IconButtonWithTooltip>
                        <ChooseLanguage />
                    </div> */}
                    
                    <Button
                        color="inherit"
                        sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(255,255,255,0.15)",
                            "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.39)",
                            },
                            borderRadius: 2,
                            px: 3,
                        }}
                        onClick={navigateToRedirectBackToMyHomeRoute}
                    >
                        {t("back_to_my_home")}
                    </Button>
                    <Button
                        color="inherit"
                        onClick={navigateToLogoutRoute}
                        startIcon={<LogoutIcon />}
                    >
                        {t("log_out")}
                    </Button>
                </Toolbar>
            </AppBar>
            {/* Main Content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    // flexGrow: 1,
                    padding: 1,
                    // transform: "scale(0.95)"
                }}
            >
                <Typography
                    variant="h2"
                    component="h2"
                    align="center"
                    style={{  fontSize:"50px", marginTop: -5 }}
                >
                    {t("page.landing_page.welcome")}
                </Typography>

                <Grid
                    container
                    columns={{ sm: 1, md:3, lg: 5}}
                    justifyContent="center"
                    // spacing={1}
                    sx={{
                        // maxWidth: 2000,
                        margin: "0 auto",
                    }}
                >
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.leads")}
                            query={leadsCountQuery}
                            pageUrl={"/leads/"}
                            showActiveTotalCountFactor={true}
                            activeCountLabel={t("page.landing_page.new")}
                            icon={<PersonOutlineIcon fontSize="inherit" />}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.clients")}
                            query={clientsCountQuery}
                            pageUrl={"/customers/"}
                            icon={<AccountBoxIcon fontSize="inherit" />}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.tasks")}
                            query={tasksCountQuery}
                            pageUrl={"/tasks/"}
                            showActiveTotalCountFactor={true}
                            activeCountLabel={t("page.landing_page.planned")}
                            icon={<CalendarMonthIcon fontSize="inherit" />}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.agreements")}
                            query={agreementsCountQuery}
                            pageUrl={"/agreements/"}
                            showActiveTotalCountFactor={true}
                            activeCountLabel={t("page.landing_page.underPreparation")}
                            icon={<HandshakeIcon fontSize="inherit" />}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.offers")}
                            query={offersCountQuery}
                            pageUrl={"/offers/"}
                            showActiveTotalCountFactor={true}
                            activeCountLabel={t("page.landing_page.underPreparation")}
                            icon={<LocalOfferIcon fontSize="inherit" />}
                        />
                    </Grid>                
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.bookings")}
                            query={bookingsCountQuery}
                            pageUrl={"/bookings/"}
                            showActiveTotalCountFactor={true}
                            activeCountLabel={t("page.landing_page.active")}
                            icon={<CalendarTodayIcon fontSize="inherit" />}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.contacts")}
                            query={contactsCountQuery}
                            pageUrl={"/contacts/"}
                            icon={<LocalPhoneIcon fontSize="inherit" />}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.products")}
                            query={productsCountQuery}
                            showActiveTotalCountFactor={true}
                            pageUrl={"/products/"}
                            icon={<ApartmentIcon fontSize="inherit" />}
                            activeCountLabel={t("page.landing_page.available")}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <LandingPageTile
                            title={t("page.landing_page.persons")}
                            query={personsCountQuery}
                            pageUrl={"/persons/"}
                            icon={<Diversity3Icon fontSize="inherit" />}
                        />
                    </Grid>
                    {salesPerimssion && (
                        <Grid item xs={1}>
                            <LandingPageTile
                                title={t("page.landing_page.overdue_payments")}
                                pageUrl="/agreement-overdue-payments/"
                                icon={<MoneyOffIcon fontSize="inherit" />}
                                query={agreementOverduePaymentCountQuery}
                                showActiveTotalCountFactor={true}
                                activeCountLabel={t("page.landing_page.unexecuted")}
                            />
                        </Grid>
                    )} 
                    {salesPerimssion && (
                        <Grid item xs={1}>
                            <LandingPageTile
                                title={t("page.landing_page.investment_docs")}
                                pageUrl="/investment-docs/"
                                icon={<FolderCopyIcon fontSize="inherit" />}
                                customStyles={specialSalesStyle}
                            />
                        </Grid>
                    )}                                      
                    {salesManagerPanelPermission && (
                        <Grid item xs={1}>
                            <LandingPageTile
                                title={t("page.landing_page.sales_manager")}
                                pageUrl="/sales-manager/"
                                icon={<AttachMoneyIcon fontSize="inherit" />}
                                customStyles={specialSalesStyle}
                            />
                        </Grid>
                    )}
                    {marketingPanelPermission && (
                        <Grid item xs={1}>
                            <LandingPageTile
                                title={t("page.landing_page.marketing_panel")}
                                pageUrl="/marketing-panel/"
                                icon={<EqualizerIcon fontSize="inherit"/>}
                                customStyles={specialSalesStyle}
                            />
                        </Grid>
                    )}
                </Grid>
            </Box>
        </Box>
    );
};

export default LandingPage;
